import React from "react";
import { Clock, Link as LinkIcon } from "lucide-react";
import { formatDelay } from "./sequenceMeta";

/**
 * WhatsApp-style chat preview for a single variant sequence.
 * Renders each sub-message as a green bubble with a relative delay label
 * (e.g. "subito", "+10s", "+25s") so the admin sees what the lead will see.
 *
 * Props:
 *   - tags: ordered list of template tags in the sequence (3-4 items)
 *   - delays: cumulative seconds from trigger, same length as tags
 *   - templates: { [tag]: {copy, link} } — the freshest copy from the DB
 *   - linkPlaceholderUrl: the dummy URL to substitute for {link} (default: nicely rendered)
 */
export default function WhatsAppPreview({ tags, delays, templates, name = "Mario" }) {
  return (
    <div
      className="rounded-2xl p-3 space-y-2"
      style={{
        background:
          "linear-gradient(180deg,#0b3d2e 0%, #126b50 100%) padding-box," +
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Cpath d='M0 0 L100 100 M100 0 L0 100' stroke='rgba(255,255,255,0.04)' stroke-width='1' /%3E%3C/svg%3E\") repeat",
        minHeight: 240,
      }}
      data-testid="wa-preview"
    >
      {tags.map((tag, i) => {
        const t = templates?.[tag];
        const text = t?.copy || "(template non in DB)";
        const linkKind = t?.link;
        const display = text
          .replace(/\{name\}/g, name)
          .replace(
            /\{link\}/g,
            linkKind
              ? `https://app.example.it/${linkKind === "imposta-password" ? "imposta-password" : linkKind === "lezione-1" ? "corso/lezione/1" : "sblocco-gratuito/bundle_234"}?…`
              : "",
          );
        return (
          <div key={tag} className="space-y-1">
            <div className="text-[10px] font-semibold flex items-center gap-1 text-white/70">
              <Clock size={10} />
              {formatDelay(delays[i] ?? 0)}
              {linkKind && (
                <span className="ml-1 inline-flex items-center gap-1 text-[9px] uppercase tracking-wider bg-white/15 rounded px-1.5 py-0.5">
                  <LinkIcon size={9} /> {linkKind}
                </span>
              )}
            </div>
            <div
              className="ml-auto max-w-[88%] rounded-2xl rounded-tr-sm px-3 py-2 text-[13px] leading-snug shadow-sm whitespace-pre-wrap"
              style={{ background: "#dcf8c6", color: "#062f1d" }}
            >
              {display}
            </div>
          </div>
        );
      })}
    </div>
  );
}
